"use client"

import MsgDeskSurfaceClient from '../host/MsgDeskSurfaceClient'
import type { DeskSurfaceClientProps } from '../host/surfaceDescriptor'
import { EmailRoutedPage } from './deskUi/EmailRoutedPage'
import { MsgDeskLoading } from './deskUi/MsgDeskLoading'

export default function EmailSurfaceClient(props: DeskSurfaceClientProps) {
  return (
    <MsgDeskSurfaceClient
      {...props}
      RoutedPage={EmailRoutedPage}
      Loading={MsgDeskLoading}
      loadInitialSubsOnMsgRoute={false}
    />
  )
}
